import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_range_slider = _resolveComponent("v-range-slider")!
  const _component_CardBank = _resolveComponent("CardBank")!
  const _component_CardAmount = _resolveComponent("CardAmount")!
  const _component_CardRatio = _resolveComponent("CardRatio")!
  const _component_CardBalance = _resolveComponent("CardBalance")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_oss_widget_embedder = _resolveComponent("oss-widget-embedder")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_BarChartCardSales = _resolveComponent("BarChartCardSales")!
  const _component_BarChartCard = _resolveComponent("BarChartCard")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_pie_chart = _resolveComponent("pie-chart")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_BarChartCardPurchase = _resolveComponent("BarChartCardPurchase")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_CashFlowPlan = _resolveComponent("CashFlowPlan")!
  const _component_ChoosePersonalisedCard = _resolveComponent("ChoosePersonalisedCard")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (
                    _ctx.emit ||
                    (_ctx.displayScenariosSelection && !_ctx.$vuetify.display.mobile) ||
                    !_ctx.selectedAccountingPeriod
                )
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": "",
                  class: _normalizeClass(
                    _ctx.displayScenariosSelection && _ctx.budgetId
                        ? 'd-flex align-center pt-2 px-1 pb-4'
                        : 'd-flex align-center px-1'
                ),
                  id: "Date"
                }, {
                  default: _withCtx(() => [
                    (_ctx.emit)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "1",
                          class: "d-flex align-center justify-center",
                          "data-cy": "Dashboard-back"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_back, {
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.emit = null), ["stop"]))
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
                        !(_ctx.emit === 'tresorerie' && _ctx.displayScenariosSelection && _ctx.budgetId) &&
                        !_ctx.selectedAccountingPeriod
                    )
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: _ctx.$vuetify.display.mobile ? '10' : '2',
                          class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'pl-2' : '')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_date_picker, {
                              hideDetails: true,
                              modelValue: _ctx.start,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.start) = $event)),
                              type: "month",
                              format: "MMMM YYYY",
                              prefixDataCy: "Dashboard-month"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["cols", "class"]))
                      : _createCommentVNode("", true),
                    (_ctx.emit === 'tresorerie' && !_ctx.$vuetify.display.mobile && _ctx.isAllowedToDashboard)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 2,
                          cols: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              outlined: "",
                              modelValue: _ctx.displayCashFlowChart,
                              "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.displayCashFlowChart) = $event)),
                                _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDisplayCashFlowChartChanged()))
                              ],
                              items: _ctx.cashChartsDisplayOptions,
                              "item-value": "id",
                              "single-line": "",
                              required: "",
                              class: _normalizeClass(_ctx.displayScenariosSelection && _ctx.budgetId ? '' : 'ml-4'),
                              "hide-details": "",
                              density: "compact",
                              "item-title": (item) => item.name
                            }, null, 8, ["modelValue", "items", "class", "item-title"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.displayScenariosSelection && !_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 3,
                          cols: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              outlined: "",
                              modelValue: _ctx.budgetId,
                              "onUpdate:modelValue": [
                                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.budgetId) = $event)),
                                _ctx.queryBudgetForecastFromBudget
                              ],
                              items: _ctx.scenarios,
                              "item-value": "id",
                              "single-line": "",
                              required: "",
                              class: "ml-4",
                              "hide-details": "",
                              density: "compact",
                              "item-title": (item) => item.name
                            }, null, 8, ["modelValue", "items", "onUpdate:modelValue", "item-title"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.displayScenariosSelection && _ctx.budgetId && !_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 4,
                          cols: "2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              outlined: "",
                              modelValue: _ctx.selectedPeriod,
                              "onUpdate:modelValue": [
                                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
                                _ctx.queryBudgetForecastFromPeriods
                              ],
                              items: _ctx.periodsList,
                              "item-value": "id",
                              "single-line": "",
                              required: "",
                              class: "ml-4",
                              "hide-details": "",
                              density: "compact",
                              "item-title": (item) => item.name
                            }, null, 8, ["modelValue", "items", "onUpdate:modelValue", "item-title"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
                        !_ctx.$vuetify.display.mobile &&
                        _ctx.emit !== 'tresorerie' &&
                        !_ctx.selectedAccountingPeriod
                    )
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 5,
                          cols: _ctx.displayScenariosSelection ? '5' : '8',
                          class: "d-flex align-self-start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio_group, {
                              modelValue: _ctx.unitOfTime,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.unitOfTime) = $event)),
                              inline: "",
                              "data-cy": "dashboard-unitOfTime",
                              class: "d-flex align-center",
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                  label: "Jour",
                                  value: "day",
                                  "data-cy": "dashboard-unitOfTime-day",
                                  class: "d-flex align-center"
                                }),
                                _createVNode(_component_v_radio, {
                                  label: "Semaine",
                                  value: "week",
                                  "data-cy": "dashboard-unitOfTime-week",
                                  class: "d-flex align-center"
                                }),
                                _createVNode(_component_v_radio, {
                                  label: "Mois",
                                  value: "month",
                                  "data-cy": "dashboard-unitOfTime-month",
                                  class: "d-flex align-center"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["cols"]))
                      : _createCommentVNode("", true),
                    (!_ctx.$vuetify.display.mobile)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 6,
                          class: "d-flex justify-end"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TutorialButtonDialog, { starterComponents: 'Dashboard;' })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (
                    !(_ctx.displayScenariosSelection && _ctx.budgetId) &&
                    _ctx.dateTicksLabels &&
                    _ctx.dateTicksLabelCount
                )
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_range_slider, {
                          modelValue: _ctx.dateRange,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateRange) = $event)),
                          min: "0",
                          max: _ctx.dateTicksLabelCount - 1,
                          "data-cy": "dashboard-slider",
                          ticks: _ctx.dateTicksLabels
                        }, null, 8, ["modelValue", "max", "ticks"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                (_ctx.enableBank)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CardBank, {
                          modelValue: _ctx.areBalancesReconciled,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.areBalancesReconciled) = $event)),
                          companyId: _ctx.companyId,
                          onOnVueDetailedChanged: _cache[9] || (_cache[9] = 
                            () => {
                                _ctx.emit = 'tresorerie';
                            }
                        ),
                          id: "TreasuryDashboard"
                        }, null, 8, ["modelValue", "companyId"])
                      ]),
                      _: 1
                    }, 8, ["cols", "class"]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalisedCards, (card, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (_ctx.isCardAmount(card))
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                          class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2'),
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CardAmount, {
                              companyId: _ctx.companyId,
                              periods: _ctx.periods,
                              indicator: card,
                              showBtnDetails: true,
                              onOnVueDetailedChanged: ($event: any) => (_ctx.onVueDetailedChanged(card)),
                              onDeleteTheCard: _cache[10] || (_cache[10] = ($event: any) => (_ctx.refresh()))
                            }, null, 8, ["companyId", "periods", "indicator", "onOnVueDetailedChanged"])
                          ]),
                          _: 2
                        }, 1032, ["cols", "class"]))
                      : (_openBlock(), _createBlock(_component_v_col, {
                          cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                          class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2'),
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CardRatio, {
                              companyId: _ctx.companyId,
                              periods: _ctx.periods,
                              indicator: card,
                              showBtnDetails: false,
                              onOnVueDetailedChanged: ($event: any) => (_ctx.onVueDetailedChanged(card)),
                              onDeleteTheCard: _cache[11] || (_cache[11] = ($event: any) => (_ctx.refresh()))
                            }, null, 8, ["companyId", "periods", "indicator", "onOnVueDetailedChanged"])
                          ]),
                          _: 2
                        }, 1032, ["cols", "class"]))
                  ], 64))
                }), 256)),
                _withDirectives(_createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CardBalance, {
                      companyId: _ctx.companyId,
                      accountableAccounts: ['411'],
                      onDisplay: _cache[12] || (_cache[12] = ($event: any) => (_ctx.checkInvoiceOrSale411Display = $event))
                    }, null, 8, ["companyId"])
                  ]),
                  _: 1
                }, 8, ["cols", "class"]), [
                  [_vShow, _ctx.checkInvoiceOrSale411Display]
                ]),
                _withDirectives(_createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CardBalance, {
                      companyId: _ctx.companyId,
                      accountableAccounts: ['401'],
                      onDisplay: _cache[13] || (_cache[13] = ($event: any) => (_ctx.checkInvoiceOrSale401Display = $event))
                    }, null, 8, ["companyId"])
                  ]),
                  _: 1
                }, 8, ["cols", "class"]), [
                  [_vShow, _ctx.checkInvoiceOrSale401Display]
                ]),
                _withDirectives(_createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CardBalance, {
                      companyId: _ctx.companyId,
                      accountableAccounts: ['421'],
                      onDisplay: _cache[14] || (_cache[14] = ($event: any) => (_ctx.checkInvoiceOrSale421Display = $event))
                    }, null, 8, ["companyId"])
                  ]),
                  _: 1
                }, 8, ["cols", "class"]), [
                  [_vShow, _ctx.checkInvoiceOrSale421Display]
                ]),
                _withDirectives(_createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CardBalance, {
                      companyId: _ctx.companyId,
                      accountableAccounts: ['455'],
                      onDisplay: _cache[15] || (_cache[15] = ($event: any) => (_ctx.checkInvoiceOrSale455Display = $event))
                    }, null, 8, ["companyId"])
                  ]),
                  _: 1
                }, 8, ["cols", "class"]), [
                  [_vShow, _ctx.checkInvoiceOrSale455Display]
                ]),
                (!_ctx.isIncomingOutgoingPayment)
                  ? _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CardBalance, {
                          companyId: _ctx.companyId,
                          accountableAccounts: ['467'],
                          onDisplay: _cache[16] || (_cache[16] = ($event: any) => (_ctx.checkInvoiceOrSale4670Display = $event))
                        }, null, 8, ["companyId"])
                      ]),
                      _: 1
                    }, 8, ["cols", "class"])), [
                      [_vShow, _ctx.checkInvoiceOrSale4670Display]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CardBalance, {
                      companyId: _ctx.companyId,
                      accountableAccounts: ['425'],
                      onDisplay: _cache[17] || (_cache[17] = ($event: any) => (_ctx.checkInvoiceOrSale4671Display = $event))
                    }, null, 8, ["companyId"])
                  ]),
                  _: 1
                }, 8, ["cols", "class"]), [
                  [_vShow, _ctx.checkInvoiceOrSale4671Display]
                ]),
                _withDirectives(_createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CardBalance, {
                      companyId: _ctx.companyId,
                      accountableAccounts: ['511', '531'],
                      onDisplay: _cache[18] || (_cache[18] = ($event: any) => (_ctx.checkInvoiceOrSale511And531Display = $event))
                    }, null, 8, ["companyId"])
                  ]),
                  _: 1
                }, 8, ["cols", "class"]), [
                  [_vShow, _ctx.checkInvoiceOrSale511And531Display]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extensionsCard, (ext) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                    class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'py-2' : 'pa-2'),
                    key: ext.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        elevation: "0",
                        class: _normalizeClass(
                            _ctx.$vuetify.display.mobile
                                ? 'default_card_mobile dashboard_card d-flex flex-column ma-0'
                                : 'default_card dashboard_card d-flex flex-column ma-0'
                        ),
                        style: _normalizeStyle(_ctx.$vuetify.display.mobile ? 'height: 100%' : 'height: 250px')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                style: {"flex-wrap":"nowrap"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    class: "d-flex flex-grow-1",
                                    style: {"height":"fit-content"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(ext.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, { class: "d-flex flex-shrink-1 flex-grow-0" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn_icon, {
                                        icon: "$fa-search-plus",
                                        onClick: ($event: any) => (ext.dialogStatus = !ext.dialogStatus),
                                        size: "small"
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_oss_widget_embedder, _mergeProps({ ref_for: true }, ext, {
                            dialogStatus: ext.dialogStatus,
                            "onUpdate:dialogStatus": ($event: any) => ((ext.dialogStatus) = $event)
                          }), null, 16, ["dialogStatus", "onUpdate:dialogStatus"])
                        ]),
                        _: 2
                      }, 1032, ["class", "style"])
                    ]),
                    _: 2
                  }, 1032, ["cols", "class"]))
                }), 128)),
                _createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '4',
                  class: "pa-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_hover, null, {
                      default: _withCtx(({ isHovering, props }) => [
                        _createVNode(_component_v_card, _mergeProps(props, {
                          elevation: isHovering ? '4' : '0',
                          class: 
                                _ctx.$vuetify.display.mobile
                                    ? 'default_card_mobile dashboard_card d-flex flex-column ma-0'
                                    : 'default_card dashboard_card d-flex flex-column ma-0'
                            ,
                          style: _ctx.$vuetify.display.mobile ? 'height: 120px' : 'height: 250px',
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.chooseAccountableKey = true))
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "fill-height",
                              id: "AddIndicatorDashboard",
                              "data-cy": "dashboard-addIndicator"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "title mx-2 my-2",
                                  style: {"height":"fit-content"}
                                }, {
                                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                                    _createTextVNode(" Ajouter un indicateur ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "d-flex justify-center align-center",
                                  style: {"height":"fit-content"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_add_icon, {
                                      "data-cy": "dashboard-new-indicator-btn",
                                      size: "small"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1040, ["elevation", "class", "style"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["cols"])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_ctx.emit]
            ]),
            (_ctx.emit === 'sales')
              ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        (!(_ctx.displayScenariosSelection && _ctx.budgetId))
                          ? (_openBlock(), _createBlock(_component_BarChartCardSales, {
                              key: 0,
                              startDate: _ctx.startDate,
                              endDate: _ctx.endDate,
                              unitOfTime: _ctx.unitOfTime,
                              activeBack: false
                            }, null, 8, ["startDate", "endDate", "unitOfTime"]))
                          : _createCommentVNode("", true),
                        (_ctx.displayScenariosSelection && _ctx.budgetId)
                          ? (_openBlock(), _createBlock(_component_BarChartCard, {
                              key: 1,
                              title: _ctx.$t('shared.salesForecastVersusActual'),
                              legend: true,
                              loading: _ctx.forecastBudgetWithActualLoading,
                              data: _ctx.salesForecastVersusActualData,
                              activeBack: false,
                              selectedPeriod: _ctx.selectedPeriod,
                              md6: false,
                              midHeight: true,
                              showYearNMinus1: true,
                              yearNMinus1: true,
                              selectedTags: []
                            }, null, 8, ["title", "loading", "data", "selectedPeriod"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (
                        _ctx.statsPartitionTag &&
                        (!_ctx.$vuetify.display.mobile || _ctx.selectedPartitionTag) &&
                        _ctx.isAllowedToDashboard
                    )
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: _ctx.$vuetify.display.mobile ? '12' : '5'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, {
                              class: _normalizeClass(
                            _ctx.$vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0 fill-height'
                                : 'default_card dashboard_card elevation-0 ma-0 fill-height'
                        )
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, {
                                  "primary-title": "",
                                  class: "d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("dashboard.sales_allocation")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.partitionTags.length && _ctx.isAllowedToDashboard)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              class: "pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_select, {
                                                  modelValue: _ctx.selectedPartitionTag,
                                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedPartitionTag) = $event)),
                                                  items: _ctx.partitionTags,
                                                  "item-value": "id",
                                                  "hide-details": "",
                                                  class: "mt-0 mb-0 pt-0 pb-0",
                                                  "data-cy": "Dashboard-selectedPartitionTag",
                                                  density: "compact",
                                                  "item-title": (item) => item.name
                                                }, {
                                                  selection: _withCtx(({ item }) => [
                                                    _createVNode(_component_v_chip, {
                                                      label: "",
                                                      size: "small"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue", "items", "item-title"])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.isAllowedToDashboard)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.selectedPath, (tag, index) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                (tag.tags && tag.tags.length)
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      class: "pl-2",
                                                      key: index
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (tag.tags && tag.tags.length)
                                                          ? (_openBlock(), _createBlock(_component_v_select, {
                                                              key: 0,
                                                              modelValue: tag.selected,
                                                              "onUpdate:modelValue": ($event: any) => ((tag.selected) = $event),
                                                              items: tag.tags,
                                                              "return-object": "",
                                                              "hide-details": "",
                                                              class: "pl-2",
                                                              density: "compact",
                                                              "item-title": (item) => item.name
                                                            }, {
                                                              selection: _withCtx(({ item }) => [
                                                                _createVNode(_component_v_chip, {
                                                                  label: "",
                                                                  size: "small"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["modelValue", "onUpdate:modelValue", "items", "item-title"]))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            }), 256))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_card_text, {
                                  style: {"text-align":"center"},
                                  class: "pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.statsPartitionTagLoading && _ctx.isAllowedToDashboard)
                                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                          key: 0,
                                          size: 70,
                                          width: 7,
                                          color: "primary",
                                          indeterminate: "",
                                          style: {"margin":"24px"}
                                        }))
                                      : (_ctx.statsPartitionTag && _ctx.isAllowedToDashboard)
                                        ? (_openBlock(), _createBlock(_component_pie_chart, {
                                            key: 1,
                                            data: _ctx.statsPartitionTag,
                                            options: {
                                    plugins: {
                                        legend: {
                                            display: _ctx.selectedPartitionTag ? true : false,
                                            position: 'bottom',
                                        },
                                    },
                                    maintainAspectRatio: false,
                                    ticks: { min: 0 },
                                },
                                            height: _ctx.$vuetify.display.mobile ? 200 : 300
                                          }, null, 8, ["data", "options", "height"]))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _: 1
                        }, 8, ["cols"]))
                      : _createCommentVNode("", true),
                    (_ctx.statsCustomers)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: _ctx.$vuetify.display.mobile ? '12' : '6'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, {
                              class: _normalizeClass(
                            _ctx.$vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        )
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { "primary-title": "" }, {
                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                    _createElementVNode("span", null, "Revenus par client", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_card_text, {
                                  style: {"text-align":"center"},
                                  class: "pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.statsCustomersLoading)
                                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                          key: 0,
                                          size: 70,
                                          width: 7,
                                          color: "primary",
                                          indeterminate: "",
                                          style: {"margin":"24px"}
                                        }))
                                      : (_ctx.statsCustomers)
                                        ? (_openBlock(), _createBlock(_component_bar_chart, {
                                            key: 1,
                                            data: _ctx.statsCustomers,
                                            options: _ctx.statsCustomersOptions,
                                            height: _ctx.$vuetify.display.mobile ? 200 : 350
                                          }, null, 8, ["data", "options", "height"]))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _: 1
                        }, 8, ["cols"]))
                      : _createCommentVNode("", true),
                    (_ctx.statsProducts)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 2,
                          cols: _ctx.$vuetify.display.mobile ? '12' : '6'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, {
                              class: _normalizeClass(
                            _ctx.$vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        )
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { "primary-title": "" }, {
                                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                                    _createElementVNode("span", null, "Revenus par produit", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_card_text, {
                                  style: {"text-align":"center"},
                                  class: "pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.statsProductsLoading)
                                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                          key: 0,
                                          size: 70,
                                          width: 7,
                                          color: "primary",
                                          indeterminate: "",
                                          style: {"margin":"24px"}
                                        }))
                                      : (_ctx.statsProducts)
                                        ? (_openBlock(), _createBlock(_component_bar_chart, {
                                            key: 1,
                                            data: _ctx.statsProducts,
                                            options: _ctx.statsCustomersOptions,
                                            height: _ctx.$vuetify.display.mobile ? 200 : 350
                                          }, null, 8, ["data", "options", "height"]))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _: 1
                        }, 8, ["cols"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : (_ctx.emit === 'costs')
                ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          (!(_ctx.displayScenariosSelection && _ctx.budgetId))
                            ? (_openBlock(), _createBlock(_component_BarChartCardPurchase, {
                                key: 0,
                                startDate: _ctx.startDate,
                                endDate: _ctx.endDate,
                                unitOfTime: _ctx.unitOfTime,
                                activeBack: false
                              }, null, 8, ["startDate", "endDate", "unitOfTime"]))
                            : _createCommentVNode("", true),
                          (_ctx.displayScenariosSelection && _ctx.budgetId)
                            ? (_openBlock(), _createBlock(_component_BarChartCard, {
                                key: 1,
                                title: _ctx.$t('shared.purchaseForecastVersusActual'),
                                legend: true,
                                loading: _ctx.forecastBudgetWithActualLoading,
                                data: _ctx.purchaseForecastVersusActualData,
                                activeBack: false,
                                selectedPeriod: _ctx.selectedPeriod,
                                md6: false,
                                midHeight: true,
                                showYearNMinus1: true,
                                yearNMinus1: false,
                                selectedTags: []
                              }, null, 8, ["title", "loading", "data", "selectedPeriod"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (
                        _ctx.partitionTags &&
                        (!_ctx.$vuetify.display.mobile || _ctx.selectedPartitionTag) &&
                        _ctx.isAllowedToDashboard
                    )
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: _ctx.$vuetify.display.mobile ? '12' : '6'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: _normalizeClass(
                            _ctx.$vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0 fill-height'
                                : 'default_card dashboard_card elevation-0 ma-0 fill-height'
                        )
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, {
                                    "primary-title": "",
                                    class: "d-flex align-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("dashboard.expenses_allocation")), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { class: "pl-2" }, {
                                            default: _withCtx(() => [
                                              (_ctx.partitionTags.length && _ctx.isAllowedToDashboard)
                                                ? (_openBlock(), _createBlock(_component_v_select, {
                                                    key: 0,
                                                    modelValue: _ctx.selectedPartitionTag,
                                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedPartitionTag) = $event)),
                                                    items: _ctx.partitionTags,
                                                    "item-value": "id",
                                                    class: "mt-0 mb-0 pt-0 pb-0",
                                                    "hide-details": "",
                                                    density: "compact",
                                                    "item-title": (item) => item.name
                                                  }, {
                                                    selection: _withCtx(({ item }) => [
                                                      _createVNode(_component_v_chip, {
                                                        label: "",
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue", "items", "item-title"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }),
                                          (
                                        _ctx.root &&
                                        _ctx.root.tags &&
                                        _ctx.root.tags.length &&
                                        _ctx.isAllowedToDashboard
                                    )
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedPath, (tag, index) => {
                                                return (_openBlock(), _createBlock(_component_v_col, {
                                                  class: _normalizeClass(index === 0 ? 'pl-2' : ''),
                                                  key: index
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_select, {
                                                      modelValue: tag.selected,
                                                      "onUpdate:modelValue": ($event: any) => ((tag.selected) = $event),
                                                      items: tag.tags,
                                                      "return-object": "",
                                                      "hide-details": "",
                                                      class: "mt-0 mb-0 pt-0 pb-0",
                                                      "onClick:appendOuter": ($event: any) => (_ctx.removeSelectedPath(index)),
                                                      density: "compact",
                                                      "item-title": "name",
                                                      "append-inner-icon": "$clear"
                                                    }, {
                                                      selection: _withCtx(({ item }) => [
                                                        _createVNode(_component_v_chip, {
                                                          label: "",
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["modelValue", "onUpdate:modelValue", "items", "onClick:appendOuter"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["class"]))
                                              }), 128))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_card_text, {
                                    style: {"text-align":"center"},
                                    class: "pa-0"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.statsPartitionTagLoading && _ctx.isAllowedToDashboard)
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 0,
                                            size: 70,
                                            width: 7,
                                            color: "primary",
                                            indeterminate: "",
                                            style: {"margin":"24px"}
                                          }))
                                        : (
                                    !_ctx.statsPartitionTagLoading &&
                                    !_ctx.statsPartitionTag &&
                                    _ctx.isAllowedToDashboard
                                )
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(" Aucun tag utilisé ")
                                            ], 64))
                                          : (_ctx.statsPartitionTag && _ctx.isAllowedToDashboard)
                                            ? (_openBlock(), _createBlock(_component_pie_chart, {
                                                key: 2,
                                                data: _ctx.statsPartitionTag,
                                                options: {
                                    plugins: {
                                        legend: {
                                            display: _ctx.selectedPartitionTag ? true : false,
                                            position: 'bottom',
                                        },
                                    },
                                    maintainAspectRatio: false,
                                    ticks: { min: 0 },
                                },
                                                height: _ctx.$vuetify.display.mobile ? 200 : 300
                                              }, null, 8, ["data", "options", "height"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _: 1
                          }, 8, ["cols"]))
                        : _createCommentVNode("", true),
                      (_ctx.statsSuppliers)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: _ctx.$vuetify.display.mobile ? '12' : '6'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: _normalizeClass(
                            _ctx.$vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        )
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { "primary-title": "" }, {
                                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                                      _createElementVNode("span", null, "Charges par fournisseur", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_card_text, {
                                    style: {"text-align":"center"},
                                    class: "pa-0"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.statsSuppliersLoading)
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 0,
                                            size: 70,
                                            width: 7,
                                            color: "primary",
                                            indeterminate: "",
                                            style: {"margin":"24px"}
                                          }))
                                        : (_ctx.statsSuppliers)
                                          ? (_openBlock(), _createBlock(_component_bar_chart, {
                                              key: 1,
                                              data: _ctx.statsSuppliers,
                                              options: _ctx.statsCustomersOptions,
                                              height: _ctx.$vuetify.display.mobile ? 200 : 350
                                            }, null, 8, ["data", "options", "height"]))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _: 1
                          }, 8, ["cols"]))
                        : _createCommentVNode("", true),
                      (_ctx.statsSocialChargesMonthly)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 2,
                            cols: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: _normalizeClass(
                            _ctx.$vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        )
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { "primary-title": "" }, {
                                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                                      _createElementVNode("span", null, "Charges de personnel", -1)
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_card_text, {
                                    style: {"text-align":"center"},
                                    class: "pa-0"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.statsSocialChargesMonthlyLoading)
                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                            key: 0,
                                            size: 70,
                                            width: 7,
                                            color: "primary",
                                            indeterminate: "",
                                            style: {"margin":"24px"}
                                          }))
                                        : (_ctx.statsSocialChargesMonthly)
                                          ? (_openBlock(), _createBlock(_component_bar_chart, {
                                              key: 1,
                                              data: _ctx.statsSocialChargesMonthly,
                                              options: _ctx.statsSocialChargesMonthlyOptions,
                                              height: _ctx.$vuetify.display.mobile ? 200 : 350
                                            }, null, 8, ["data", "options", "height"]))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : (_ctx.emit === 'profitAndLoss')
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 4,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        (_ctx.displayScenariosSelection && _ctx.budgetId)
                          ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_BarChartCard, {
                                  title: _ctx.$t('shared.profitAndLossForecastVersusActual'),
                                  legend: true,
                                  loading: _ctx.forecastBudgetWithActualLoading,
                                  data: _ctx.profitAndLossForecastVersusActualData,
                                  activeBack: false,
                                  selectedPeriod: _ctx.selectedPeriod,
                                  md6: false,
                                  midHeight: true,
                                  showYearNMinus1: false,
                                  yearNMinus1: false,
                                  selectedTags: []
                                }, null, 8, ["title", "loading", "data", "selectedPeriod"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!(_ctx.displayScenariosSelection && _ctx.budgetId))
                          ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_BarChartCard, {
                                  title: _ctx.$t('shared.profitAndLoss'),
                                  loading: 
                            _ctx.statsProfitAndLossDetail
                                ? _ctx.statsProfitAndLossPartitionMonthlyLoading
                                : _ctx.statsProfitAndLossMonthlyLoading
                        ,
                                  data: 
                            _ctx.statsProfitAndLossDetail
                                ? _ctx.statsProfitAndLossPartitionMonthlyData
                                : _ctx.statsProfitAndLossMonthlyData
                        ,
                                  activeBack: false,
                                  yearNMinus1: _ctx.statsProfitAndLossYearNMinus1,
                                  showYearNMinus1: true,
                                  onOnYearNMinus1Changed: _cache[22] || (_cache[22] = 
                            (value) => {
                                _ctx.statsProfitAndLossYearNMinus1 = value;
                            }
                        ),
                                  md6: false,
                                  selectedTags: []
                                }, null, 8, ["title", "loading", "data", "yearNMinus1"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : (_ctx.emit === 'tresorerie')
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 5 }, {
                        default: _withCtx(() => [
                          (!_ctx.displayCashFlowChart)
                            ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card, {
                                    class: _normalizeClass(
                            _ctx.$vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        )
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_title, { "primary-title": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: _ctx.$vuetify.display.mobile ? 12 : 6,
                                                class: "ml-0 mt-0 mb-0 pt-0 pb-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t("shared.cashBalance")), 1)
                                                ]),
                                                _: 1
                                              }, 8, ["cols"]),
                                              _createVNode(_component_v_col, {
                                                cols: _ctx.$vuetify.display.mobile ? 12 : 6
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.cashBalancesOutputs.length > 1)
                                                    ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                                        key: 0,
                                                        modelValue: _ctx.cashBalance,
                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.cashBalance) = $event)),
                                                        items: _ctx.cashBalancesOutputs,
                                                        "item-title": _ctx.getBankAccountName,
                                                        "return-object": "",
                                                        class: "mt-2 mb-0 pt-0 pb-0 mr-4",
                                                        label: "Compte bancaire",
                                                        density: "compact"
                                                      }, null, 8, ["modelValue", "items", "item-title"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }, 8, ["cols"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_card_text, {
                                        style: {"text-align":"center"},
                                        class: "pa-0"
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.cashBalanceLoading)
                                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                key: 0,
                                                size: 70,
                                                width: 7,
                                                color: "primary",
                                                indeterminate: "",
                                                style: {"margin":"24px"}
                                              }))
                                            : (_ctx.cashBalance)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  (_ctx.cashBalance)
                                                    ? (_openBlock(), _createBlock(_component_bar_chart, {
                                                        data: _ctx.cashBalance,
                                                        options: _ctx.cashBalanceOptions,
                                                        height: _ctx.$vuetify.display.mobile ? 200 : 350,
                                                        key: _ctx.cashBalance.bankAccount.id
                                                      }, null, 8, ["data", "options", "height"]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              : (_ctx.addBankAccountAvailable)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    _cache[34] || (_cache[34] = _createElementVNode("p", null, " Ajoutez un compte bancaire pour visualiser l'évolution du solde bancaire ", -1)),
                                                    _createVNode(_component_v_btn, {
                                                      class: "btn_card",
                                                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.createBankAccount())),
                                                      rounded: "",
                                                      elevation: "0",
                                                      size: "small"
                                                    }, {
                                                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                                                        _createTextVNode(" Ajoutez un compte bancaire ")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_1, "Pas de donnée pour cette période"))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.displayCashFlowChart)
                            ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card, {
                                    class: _normalizeClass(
                            _ctx.$vuetify.display.mobile
                                ? 'default_card_mobile elevation-0 ma-0'
                                : 'default_card dashboard_card elevation-0 ma-0'
                        )
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_title, { "primary-title": "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("shared.cashFlowPlan")), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_card_text, {
                                        style: {"text-align":"center"},
                                        class: "pa-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CashFlowPlan, {
                                            companyId: _ctx.companyId,
                                            inBudgetId: _ctx.budgetId,
                                            startDate: _ctx.startDate,
                                            endDate: _ctx.endDate,
                                            selectedPeriod: _ctx.selectedPeriod,
                                            onPeriodsListChanged: _ctx.onPeriodsListChanged
                                          }, null, 8, ["companyId", "inBudgetId", "startDate", "endDate", "selectedPeriod", "onPeriodsListChanged"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : (_ctx.emit?.id)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 6 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_BarChartCard, {
                                  title: _ctx.emit.name,
                                  data: this.emitDetailFormatedData,
                                  loading: _ctx.emitDetailLoading,
                                  activeBack: false,
                                  yearNMinus1: _ctx.yearMinus1EmitDisplayed,
                                  showYearNMinus1: true,
                                  onOnYearNMinus1Changed: _cache[25] || (_cache[25] = 
                            (value) => {
                                _ctx.yearMinus1EmitDisplayed = value;
                            }
                        ),
                                  md6: false,
                                  selectedTags: []
                                }, null, 8, ["title", "data", "loading", "yearNMinus1"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
            _createVNode(_component_ChoosePersonalisedCard, {
              modelValue: _ctx.chooseAccountableKey,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.chooseAccountableKey) = $event)),
              companyId: _ctx.companyId,
              onUpdate_dashboardSettings: _cache[27] || (_cache[27] = ($event: any) => (_ctx.refresh()))
            }, null, 8, ["modelValue", "companyId"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}